module.exports = __webpack_public_path__ + "imgs/website.57a4be922ece97aa4cfcdd0ded8ee2de.svg";